import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { GenericResponseDto } from "../models/generic-response.dto";
import { ValidateLogin } from "../models/validate-login.dto";
import { BehaviorSubject, Observable } from "rxjs";
import { UserMobileAppQrCodeShowHide } from "../models/common/userMobileAppQrCodeShowHide";
import { ApiCacheService } from "./api-cache.service";

@Injectable({
  providedIn: "root",
})
export class UserManagementService {
  private readonly userManagementBaseURL = environment.baseUrl + "/User";
  private readonly validateLoginUrl =
    this.userManagementBaseURL + "/ValidateLoginAsync";
  private readonly validateLoginTtl = 5 * 60 * 1000; // 5 minutes

  public isInventoryAccessChange = new BehaviorSubject<boolean>(false);
  public userRole = new BehaviorSubject<ValidateLogin | null>(null);
  public inventoryAccess = true;

  constructor(
    private _http: HttpClient,
    private _apiCache: ApiCacheService
  ) {}

  public validateLogin(
    forceNew?: boolean
  ): Observable<GenericResponseDto<ValidateLogin>> {
    if (forceNew) {
      this._apiCache.invalidate(this.validateLoginUrl);
    }
    return this._apiCache.get<GenericResponseDto<ValidateLogin>>(
      this.validateLoginUrl,
      this.validateLoginTtl
    );
  }

  public userMobileAppQrCodeShowHide(
    payload: UserMobileAppQrCodeShowHide
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      `${this.userManagementBaseURL}/UserMobileAppQrCodeShowHide`,
      payload
    );
  }
}
